module.exports = __webpack_public_path__ + "static/img/antares-sgas.0c114ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/antares-sgas.png
// module id = I+5t
// module chunks = 0